(function() {

  'use strict';

  function CepResource($resource, URL, PATH, PATH_V2, URLAPIPEDIDO) {
    return $resource(URL + PATH + '/zipcodes/:cep', {
      cep: '@cep'
    }, {
      shippingOptions: {
        method: 'GET',
        url: URL + PATH_V2 + '/zipcodes/:cep/shipping-options/:pj',
        isArray: true,
        params: {
          pj: '@pj'
        }
      },

      veiculos: {
        method: 'GET',
        url: URL + PATH + '/zipcodes/:cep/vehicles',
        isArray: true
      },

      veiculosDadosColeta: {
        method: 'GET',
        url: URLAPIPEDIDO + '/v2/areas/:cep'
      }

    });
  };

  angular.module('mandaeApp')
    .factory('CepResource', CepResource);

})();
